module.exports = __webpack_public_path__ + "LatoLatin-HairlineItalic.0937a9a93f08a2959cb2.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.woff
// module chunks = styles